export const shortCutList = (_rc='') => {

    let enterCouponData = {
        "isShow": true,
        "type": 'function',
        "name": 'nshop.popup',
        "params": {
            "popup_service": 'nshop_coupon'
        },
    };
    if (userData.site==='lineagem') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/lms/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='bns2') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/bns2/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='tricksterm') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/tricksterm/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='h3') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/h3/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2m') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/l2m/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2mru') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/l2mru/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='l2mnu') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/l2mnu/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='h2') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/h2/kr/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }
    if (userData.site==='linw') {
        enterCouponData.url = `https://${_rc}nshop.plaync.com/shop/linw/coupon`;
        enterCouponData.type = "external";
        enterCouponData.popOption = "";
    }

    return {
        "mypage": {
            "isShow": true,
            "type": '', // popup, function, external
            "url": `https://${_rc}id.plaync.com/index`
        },
        "ncoin": {
            "isShow": true,
            "type": 'popup',
            "popOption": 'width=480,height=650,toolbar=0,menubar=0',
            "url": `https://${_rc? 'rc2-': ''}ncoin.plaync.com/ncoin/charge`
        },
        "enterCoupon": enterCouponData,
        "cs": {
            "isShow": true,
            "type": '',
            "url": `https://${_rc}help.plaync.com/qna/list/ticket`
        },
        "charHome": {
            "isShow": false,
            "type": '', 
            "url": '/my/profile/character'
        },
        "security": {
            "isShow": false,
            "type": '', 
            "url": '',
        },
        "mynshop": {
            "isShow": false,
            "type": '',
            "url": ""
        },
        "coupon": {
            "isShow": false,
            "type": '',
            "url": ""
        },
        "couponGame": {
            "isShow": false,
            "type": '',
            "url": ""
        },
        "npoint": {
            "isShow": false,
            "type": '',
            "url": ""
        },
        "npointGame": {
            "isShow": false,
            "type": '',
            "url": ""
        },
        "gift": {
            "isShow": false,
            "type": '',
            "url": ""
        },
        "ticket": {
            "isShow": false,
            "type": '',
            "url": ""
        },
    };
}